import {Component} from '@angular/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {equalValidator} from '@services/user/validators/equal-validator.directive.service';

@Component({
    selector: 'scitis-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent {

  public cancelButtonText = '';
  public okButtonText = '';
  public form: UntypedFormGroup = this.formBuilder.group({});

  private readonly passwordRegex = '^(?=.*\\d)(?=.*[a-zA-Z]).{8,}$';

  constructor(
      private activeModal: NgbActiveModal,
      private translate: TranslateService,
      private formBuilder: UntypedFormBuilder) {
    this.setMessages();
    this.generateForm();
  }

  get disableOkButton(): boolean {
    return this.form.invalid;
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onOk(_$event: boolean) {
    this.activeModal.close(this.form.controls.password.value);
  }

  onCancel(_$event: boolean) {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  private setMessages(): void {
    this.okButtonText = this.translate.instant('Save');
    this.cancelButtonText = this.translate.instant('Cancel');
  }

  private generateForm(): void {
    this.form = this.formBuilder.group({
      password: ['', [Validators.required, Validators.pattern(this.passwordRegex)]],
      confirmPassword: ['', Validators.required]
    });

    this.form.get('confirmPassword')?.setValidators([Validators.required, equalValidator(this.form.controls.password)]);
  }

}
